import { motion } from 'framer-motion'
import { Link } from '@tanstack/react-router'
import { Book, ArrowRight, Sparkles } from 'lucide-react'
import { Button } from '@/components/ui/Button'
import MarketingNav from '@/components/marketing/MarketingNav'
import MarketingFooter from '@/components/marketing/MarketingFooter'

export default function DocsPage() {
  return (
    <div className="min-h-screen bg-surface-950">
      <MarketingNav />
      
      <section className="relative pt-32 pb-32 overflow-hidden">
        <div className="absolute inset-0 gradient-mesh opacity-30" />
        <div className="absolute inset-0 grid-pattern" />
        
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500/10 border border-primary-500/20 mb-8"
          >
            <Book className="w-4 h-4 text-primary-400" />
            <span className="text-sm font-medium text-primary-300">Documentation</span>
          </motion.div>
          
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="text-5xl md:text-6xl font-bold text-white leading-tight mb-6"
          >
            Documentation
            <br />
            <span className="text-gradient">Launching Soon</span>
          </motion.h1>
          
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="text-xl text-surface-300 max-w-2xl mx-auto leading-relaxed mb-12"
          >
            We're working on comprehensive guides, API references, and tutorials 
            to help you get the most out of 3DMakerly.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
            className="flex flex-col sm:flex-row items-center justify-center gap-4"
          >
            <Link to="/signup">
              <Button variant="primary" size="lg">
                <Sparkles className="w-5 h-5" />
                Get Early Access
              </Button>
            </Link>
            <Link to="/">
              <Button variant="secondary" size="lg">
                Back to Home
                <ArrowRight className="w-5 h-5" />
              </Button>
            </Link>
          </motion.div>
        </div>
      </section>

      <MarketingFooter />
    </div>
  )
}
